<template>
  <div :ref="campaignInfo.uuid" style="position: relative;">
    <div class="card-actions">
      <!-- Archivar / Desarchivar -->
      <button
        v-if="!isArchived"
        :id="`archive_campaign${campaignInfo.uuid}`"
        class="card-action-btn"
        :disabled="disabled_archive"
        @click="archivedCampaign(campaignInfo.uuid)"
      >
        <feather-icon icon="ArchiveIcon" size="14" />
        <b-tooltip :target="`archive_campaign${campaignInfo.uuid}`" triggers="hover" placement="bottom">{{ $t('archiveCampaign') }}</b-tooltip>
      </button>
      <button
        v-if="isArchived"
        :id="`unarchive_campaign${campaignInfo.uuid}`"
        class="card-action-btn"
        :disabled="!disabled_archive"
        @click="archivedCampaign(campaignInfo.uuid)"
      >
        <b-icon-arrow-up-square class="arrowSquare" />
        <b-tooltip :target="`unarchive_campaign${campaignInfo.uuid}`" triggers="hover" placement="bottom">{{ $t('unarchiveCampaign') }}</b-tooltip>
      </button>
      <!-- Divisor -->
      <span class="card-action-divider"></span>
      <!-- Eliminar -->
      <button
        :id="`delete_campaign${campaignInfo.uuid}`"
        class="card-action-btn card-action-btn--danger"
        :disabled="disabledDeleteCampaign()"
        @click="deletedCampaign(campaignInfo.uuid, isArchived)"
      >
        <feather-icon icon="Trash2Icon" size="14" />
        <b-tooltip :target="`delete_campaign${campaignInfo.uuid}`" triggers="hover" placement="bottom">{{ $t('deleteCampaign') }}</b-tooltip>
      </button>
    </div>
    <b-card
      :img-src="verifyAsset(campaignInfo.cover)"
      img-alt="Profile Cover Photo"
      img-top
      class="card-profile"
    >
      <div class="profile-image-wrapper">
        <div class="profile-image p-0">
          <b-avatar
            size="114"
            class="campaign-logo-card bg-image-card"
            :src="verifyAsset(campaignInfo.logo)"
          />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <h3 class="text-overflow mb-0" :class="showYtWarning ? 'mr-50' : ''">{{ campaignInfo.name }}</h3>
        <span
          v-if="showYtWarning"
          :id="`yt-warn-${campaignInfo.uuid}`"
          class="flex-shrink-0 cursor-pointer text-warning"
          style="line-height:1"
        >
          <feather-icon icon="AlertCircleIcon" size="18" />
        </span>
        <b-popover
          v-if="showYtWarning"
          :target="`yt-warn-${campaignInfo.uuid}`"
          triggers="hover focus"
          placement="top"
          variant="warning"
        >
          <template #title>{{ $t('campaigns.youtube_banner_editable_title') }}</template>
          <p class="mb-75" style="font-size:12px;color:#555;line-height:1.45;">{{ $t('campaigns.youtube_banner_editable_msg') }}</p>
          <b-button
            size="sm"
            variant="warning"
            block
            @click="$router.push({ name: 'brief', params: { uuid: campaignInfo.uuid }, query: { openYoutube: '1' } })"
          >
            {{ $t('campaigns.youtube_banner_editable_btn') }}
          </b-button>
        </b-popover>
      </div>
      <b-badge
        class="profile-badge"
        variant="light-warning"
        v-if="isArchived"
      >
        {{ $t('oneCampaigninactive')}}
      </b-badge>
      <b-badge
        class="profile-badge"
        variant="light-success"
        v-else
      >
        {{ $t('oneCampaignactive')}}
      </b-badge>
      <p v-if="campaignInfo.code_campaign" class="text-muted font-small-2 mt-50 mb-0">
        <feather-icon icon="LinkIcon" size="11" class="mr-25" />Código de campaña:<span class="font-weight-bold">{{ campaignInfo.code_campaign }}</span>
      </p>
      <hr class="mb-2">

      <!-- follower projects rank -->
      <div v-if="groupRol !== 'realty'" class="mb-1">
        <div class="d-flex justify-content-between flex-wrap col-12">
          <div class="mb-1">
            <h6 class="text-muted font-weight-bolder">
              {{ $t('proposalscard') }}
            </h6>
            <h3 class="mb-0">
              {{ campaignInfo.stats_fields.proposals }}
            </h3>
          </div>
          <div class="mb-1">
            <h6 class="text-muted font-weight-bolder">
              {{ $t('campaigns.approvedProfiles') }}
            </h6>
            <h3 class="mb-1">
              {{ totalApproved()}}
            </h3>
          </div>
          <div class="mb-1">
            <h6 class="text-muted font-weight-bolder">
              {{ $t('publishedcard') }}
            </h6>
            <h3 class="mb-0">
              {{ campaignInfo.stats_fields.contents_published }}
            </h3>
          </div>
        </div>
        <b-button
          variant="flat-light"
          class="btn-icon"
          @click="show_collapse = !show_collapse"
        >
          <feather-icon icon="ChevronUpIcon" size="20" v-if="show_collapse"/>
          <feather-icon icon="ChevronDownIcon" size="20" v-else/>
        </b-button>
        <b-collapse v-model="show_collapse">
          <div class="col-12 d-flex justify-content-between flex-wrap">
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{$t('productioncard') }}
              </h6>
              <h3 class="mb-0">
                {{ campaignInfo.stats_fields.production }}
              </h3>
            </div>
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('campaigns.rejected') }}
              </h6>
              <h3 class="mb-1">
                {{ campaignInfo.stats_fields.rejected }}
              </h3>
            </div>
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('campaigns.pending') }}
              </h6>
              <h3 class="mb-1">
                {{ campaignInfo.stats_fields.pending }}
              </h3>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-between flex-wrap">
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('campaigns.tradingProfiles') }}
              </h6>
              <h3 class="mb-1">
                {{ campaignInfo.stats_fields.trading }}
              </h3>
            </div>
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('campaigns.submitted') }}
              </h6>
              <h3 class="mb-1">
                {{ campaignInfo.stats_fields.submitted }}
              </h3>
            </div>
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('campaigns.onboarding') }}
              </h6>
              <h3 class="mb-1">
                {{ campaignInfo.stats_fields.onboarding }}
              </h3>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-around flex-wrap">
            <div class="mb-1">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('budgetcard') }}
              </h6>
              <h3 class="mb-0">
                $ {{ separatebycomma(campaignInfo.budget) }}
              </h3>
            </div>
            <div class="mb-1" v-if="groupRol !== 'realty'">
              <h6 class="text-muted font-weight-bolder">
                {{ $t('spentcard') }}
              </h6>
              <h3 class="mb-0">
                $ {{ separatebycomma(campaignInfo.stats_fields.spent) }}
              </h3>
            </div>
          </div>
        </b-collapse>
      </div>
      <div v-else class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 class="text-muted font-weight-bolder">
            {{$t('locationsProposal')}}
          </h6>
          <h3 class="mb-0">
            {{ campaignInfo.stats_locations.locations }}
          </h3>
        </div>
        <div>
          <h6 class="text-muted font-weight-bolder">
            {{$t('locationsApproved')}}
          </h6>
          <h3 class="mb-0">
            {{ campaignInfo.stats_locations.approved }}
          </h3>
        </div>
        <div>
          <h6 class="text-muted font-weight-bolder">
            {{$t('locationsRunning')}}
          </h6>
          <h3 class="mb-0">
            {{ campaignInfo.stats_locations.running }}
          </h3>
        </div>
      </div>
      <b-row v-if="!show_collapse">
        <b-col lg="12">
          <h6 class="text-muted font-weight-bolder">
            {{ $t('budgetcard') }}
          </h6>
          <h3 class="mb-0">
            $ {{ separatebycomma(campaignInfo.budget) }}
          </h3>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="d-flex justify-content-center mb-1">
          <router-link class="botonResponsive d-flex align-items-stretch" :to="getUrl(campaignInfo.uuid)">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :disabled="isArchived"
            >
              {{ $t('campaigndetail') }}
            </b-button>
          </router-link>
        </b-col>
        <b-col class="d-flex justify-content-center mb-1">
          <router-link class="botonResponsive d-flex align-items-stretch" :to="'/brief/'+campaignInfo.uuid">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :disabled="isArchived"
            >
              {{ $t('campaignbrief') }}
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <!--/ follower projects rank -->
    </b-card>

    <!-- ── Modal confirmar archivar / desarchivar ── -->
    <b-modal
      v-model="showArchiveModal"
      size="md"
      centered
      hide-footer
      hide-header
      body-class="p-0"
    >
      <div class="arch-modal-header">
        <div class="arch-modal-header__title">
          <feather-icon :icon="isArchived ? 'UploadIcon' : 'ArchiveIcon'" size="18" class="mr-75" />
          {{ isArchived ? $t('campaigns.disarchivedCampaign?') : $t('campaigns.archivedCampaign?') }}
        </div>
        <feather-icon
          icon="XIcon"
          size="20"
          class="arch-modal-header__close"
          @click="showArchiveModal = false"
        />
      </div>

      <div class="del-modal-body">
        <div class="arch-modal-info">
          <feather-icon icon="InfoIcon" size="14" class="mr-50 flex-shrink-0" />
          <span>Esta acción <strong>se puede deshacer</strong> — podrás {{ isArchived ? 'archivar' : 'desarchivar' }} la campaña cuando quieras.</span>
        </div>

        <p class="del-modal-question">
          {{ isArchived ? $t('campaigns.disarchivedCampaign?') : $t('campaigns.archivedCampaign?') }}
        </p>

        <div class="del-modal-campaign-card">
          <b-avatar
            :src="verifyAsset(campaignInfo.logo)"
            size="40"
            class="del-modal-campaign-card__avatar"
          />
          <div class="del-modal-campaign-card__info">
            <p class="del-modal-campaign-card__name">{{ campaignInfo.name }}</p>
            <p class="del-modal-campaign-card__meta">
              <feather-icon icon="UsersIcon" size="12" class="mr-25" />
              {{ campaignInfo.stats_fields.proposals }} propuestas vinculadas
            </p>
          </div>
        </div>
      </div>

      <div class="del-modal-footer">
        <b-button variant="secondary" @click="showArchiveModal = false">
          <feather-icon icon="XCircleIcon" size="14" class="mr-50" />
          {{ $t('campaigns.realty.cancel') }}
        </b-button>
        <b-button variant="primary" @click="confirmArchive()">
          <feather-icon :icon="isArchived ? 'UploadIcon' : 'ArchiveIcon'" size="14" class="mr-50" />
          {{ $t('campaigns.sure') }}
        </b-button>
      </div>
    </b-modal>

    <!-- ── Modal confirmar eliminación ── -->
    <b-modal
      v-model="showDeleteModal"
      size="md"
      centered
      hide-footer
      hide-header
      body-class="p-0"
    >
      <!-- Header rojo -->
      <div class="del-modal-header">
        <div class="del-modal-header__title">
          <feather-icon icon="AlertTriangleIcon" size="18" class="mr-75" />
          {{ $t('campaigns.textConfirmCampaign') }}
        </div>
        <feather-icon
          icon="XIcon"
          size="20"
          class="del-modal-header__close"
          @click="showDeleteModal = false"
        />
      </div>

      <!-- Body -->
      <div class="del-modal-body">
        <!-- Alerta de advertencia -->
        <div class="del-modal-warning">
          <strong>¡CUIDADO!</strong> {{ $t('campaigns.textCampaign') }}
        </div>

        <p class="del-modal-question">¿Estás seguro que deseas eliminar la siguiente campaña?</p>

        <!-- Card info campaña -->
        <div class="del-modal-campaign-card">
          <b-avatar
            :src="verifyAsset(campaignInfo.logo)"
            size="40"
            class="del-modal-campaign-card__avatar"
          />
          <div class="del-modal-campaign-card__info">
            <p class="del-modal-campaign-card__name">{{ campaignInfo.name }}</p>
            <p class="del-modal-campaign-card__meta">
              <feather-icon icon="UsersIcon" size="12" class="mr-25" />
              {{ campaignInfo.stats_fields.proposals }} propuestas vinculadas
            </p>
          </div>
        </div>

        <p class="del-modal-note">
          <feather-icon icon="InfoIcon" size="13" class="mr-25" />
          Al eliminar esta campaña, toda la información asociada se perderá permanentemente.
        </p>
      </div>

      <!-- Footer -->
      <div class="del-modal-footer">
        <b-button variant="secondary" @click="showDeleteModal = false">
          <feather-icon icon="XCircleIcon" size="14" class="mr-50" />
          {{ $t('campaigns.realty.cancel') }}
        </b-button>
        <b-button variant="danger" @click="confirmDelete()">
          <feather-icon icon="Trash2Icon" size="14" class="mr-50" />
          {{ $t('campaigns.msjConfirmCampaign') }}
        </b-button>
      </div>
    </b-modal>

  </div>

</template>

<script>
import {
  BRow, BCol, BCard, BAvatar, BBadge, BButton, BCollapse, BTooltip, BModal, BPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import service from '@/services/dashboard'
import { getUserData, hasPermission } from '@/libs/utils/user'
import { verifyAsset } from '@/libs/utils/urls'

export default {
  props: {
    campaignData: {
      default: () => {}
    },
    campaignArchived: {
      default: () => false
    }
  },
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
    BBadge,
    BButton,
    BCollapse,
    BTooltip,
    BModal,
    BPopover,
  },
  directives: {
    Ripple,
  },
  data () {
    return {
      verifyAsset,
      getUserData,
      campaignInfo: this.campaignData,
      isArchived: this.campaignArchived,
      groupRol: '',
      disabled_archive: false,
      show_collapse: false,
      showDeleteModal: false,
      pendingDeleteUuid: null,
      pendingDeleteIsArchived: null,
      showArchiveModal: false,
    }
  },
  beforeCreate () {
    this.$store.commit('appConfig/UPDATE_DROPDOWN_MENU_HIDDEN', true)
  },
  created () {
    this.getGroup()
    if (this.disabledChangeCampaign()) {
      this.disabled_archive = true;
    } else {
      this.disabled_archive = this.isArchived;
    }
  },
  computed: {
    showYtWarning() {
      return (
        !this.campaignInfo.channel_brand_youtube &&
        this.campaignInfo.is_editable_by_api &&
        !!this.campaignInfo.code_campaign
      )
    }
  },
  methods: {
    totalApproved () {
      const total_approved = [
        this.campaignInfo.stats_fields.approved,
        this.campaignInfo.stats_fields.onboarding,
        this.campaignInfo.stats_fields.production,
        this.campaignInfo.stats_fields.published,
        this.campaignInfo.stats_fields.spent,
        this.campaignInfo.stats_fields.submitted,
        this.campaignInfo.stats_fields.trading,
      ].reduce((sum, val) => sum + (Number(val) || 0), 0);
      return total_approved
    },
    isSuperUser() {
      return getUserData().is_superuser
    },
    getUrl(campaign_uuid) {
      if (this.groupRol === 'realty') return `/realty/campaign/${campaign_uuid}`
      return `/campaign/${campaign_uuid}`
    },
    getGroup () {
      const user = JSON.parse(localStorage.userData)
      this.groupRol = user.groups[0].name
    },
    separatebycomma (num) {
      if (num === null) return 0
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    archivedCampaign () {
      this.showArchiveModal = true
    },
    confirmArchive () {
      this.showArchiveModal = false
      const formData = new FormData()
      formData.append('uuid', this.campaignInfo.uuid)
      formData.append('active', true)
      formData.append('is_archived', !this.isArchived)
      service.updateCampaign(this.campaignInfo.uuid, formData)
        .then(() => {
          if (this.isArchived) {
            this.$emit('has_been_desarchived', this.campaignInfo)
          } else {
            this.$emit('has_been_archived', this.campaignInfo)
          }
        })
    },
    deletedCampaign (uuid, is_archived) {
      if (this.disabledDeleteCampaign()) return
      this.pendingDeleteUuid = uuid
      this.pendingDeleteIsArchived = is_archived
      this.showDeleteModal = true
    },
    confirmDelete () {
      const uuid = this.pendingDeleteUuid
      const is_archived = this.pendingDeleteIsArchived
      this.showDeleteModal = false
      const formData = new FormData()
      formData.append('uuid', uuid)
      formData.append('active', false)
      formData.append('is_archived', this.campaignInfo.is_archived)
      service.updateCampaign(uuid, formData)
        .then(() => {
          this.$refs[uuid].parentElement.remove()
          this.$emit('deletedCampaign', is_archived, uuid)
        })
    },
    disabledDeleteCampaign() {
      return !hasPermission('delete_campaign')
    },
    disabledChangeCampaign() {
      return !hasPermission('change_campaign')
    },
  }
}
</script>

<style scoped>

  .card-profile .card-img-top {
    object-fit: fill;
    background-color: #f5f5f5;
    height: 220px;
  }
  .objetfit img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  .arrowSquare {
    width: 14px;
    height: 14px;
  }
  .text-overflow {
    display: -webkit-box !important;
    -webkit-line-clamp: 1 !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* ── Grupo de acciones de la tarjeta ── */
  .card-actions {
    position: absolute;
    z-index: 9;
    top: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(6px);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 20px;
    padding: 4px 6px;
    gap: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  div:hover > .card-actions {
    opacity: 1;
  }

  .card-action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: #6e6b7b;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    padding: 0;
  }
  .card-action-btn:hover:not(:disabled) {
    background: rgba(115, 103, 240, 0.1);
    color: #7367f0;
  }
  .card-action-btn:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .card-action-btn--danger:hover:not(:disabled) {
    background: rgba(234, 84, 85, 0.1);
    color: #ea5455;
  }

  .card-action-divider {
    width: 1px;
    height: 16px;
    background: rgba(0, 0, 0, 0.1);
    margin: 0 2px;
  }
</style>

<style>
  .bg-image-card {
    background: transparent !important;
  }
  .campaign-logo-card img {
    object-fit: cover !important;
  }

  /* ── Modal archivar campaña ── */
  .arch-modal-header {
    background: #7367f0;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px 6px 0 0;
  }
  .arch-modal-header__title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .arch-modal-header__close {
    color: rgba(255,255,255,0.8);
    cursor: pointer;
    transition: color 0.15s;
  }
  .arch-modal-header__close:hover {
    color: #fff;
  }
  .arch-modal-info {
    background: #eff8ff;
    border-left: 4px solid #7367f0;
    border-radius: 4px;
    padding: 10px 14px;
    font-size: 16px;
    color: #4a4a6a;
    margin-bottom: 16px;
    line-height: 1.5;
    display: flex;
    align-items: flex-start;
    gap: 6px;
  }
  .arch-modal-info .flex-shrink-0 {
    flex-shrink: 0;
    margin-top: 2px;
  }

  /* ── Modal eliminar campaña ── */
  .del-modal-header {
    background: #ea5455;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px 6px 0 0;
  }
  .del-modal-header__title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .del-modal-header__close {
    color: rgba(255,255,255,0.8);
    cursor: pointer;
    transition: color 0.15s;
  }
  .del-modal-header__close:hover {
    color: #fff;
  }
  .del-modal-body {
    padding: 20px 24px 8px;
  }
  .del-modal-warning {
    background: #fce8e8;
    border-left: 4px solid #ea5455;
    border-radius: 4px;
    padding: 10px 14px;
    font-size: 16px;
    color: #7d2222;
    margin-bottom: 16px;
    line-height: 1.5;
  }
  .del-modal-question {
    font-size: 18px;
    color: #5e5873;
    margin-bottom: 12px;
  }
  .del-modal-campaign-card {
    border: 1.5px solid #f5c6c6;
    background: #fff8f8;
    border-radius: 6px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  .del-modal-campaign-card__info {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  .del-modal-campaign-card__name {
    font-weight: 600;
    font-size: 18px;
    color: #2d2d2d;
    margin: 0;
  }
  .del-modal-campaign-card__meta {
    font-size: 16px;
    color: #888;
    margin: 0;
    display: flex;
    align-items: center;
  }
  .del-modal-note {
    font-size: 16px;
    color: #888;
    display: flex;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 4px;
    line-height: 1.5;
  }
  .del-modal-footer {
    padding: 12px 24px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  /* ── YouTube warning popover ── */
  .b-popover-warning .popover-header {
    color: #fff !important;
  }
  .b-popover-warning .popover-body {
    color: #000 !important;
  }
</style>